var legacyViewport = 'fx_2d2fb1e5_2datsy0';

export { legacyViewport };
//# sourceMappingURL=legacyScrollArea.vanilla.mjs.map
